'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListTypeCover = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseButtons = require('@bibliocommons/base-buttons');

var _listJacketCover = require('../../list-jacket-cover');

var _listJacketCover2 = _interopRequireDefault(_listJacketCover);

require('../styles/ListTypeCover.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListTypeCover = exports.ListTypeCover = function (_BcReactComponent) {
  _inherits(ListTypeCover, _BcReactComponent);

  function ListTypeCover(props) {
    _classCallCheck(this, ListTypeCover);

    var _this = _possibleConstructorReturn(this, (ListTypeCover.__proto__ || Object.getPrototypeOf(ListTypeCover)).call(this, props));

    _this.bindAll('handleClick');
    return _this;
  }

  _createClass(ListTypeCover, [{
    key: 'handleClick',
    value: function handleClick() {
      this.props.handleClick(this.props.type);
    }
  }, {
    key: 'renderDescription',
    value: function renderDescription() {
      if (this.props.description) {
        return _react2.default.createElement(
          'div',
          { className: 'list-type-description' },
          this.props.description
        );
      }

      return null;
    }
  }, {
    key: 'renderListTypeTitle',
    value: function renderListTypeTitle() {
      if (this.props.type === 'other') {
        return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_category_guides_recommendations' });
      }

      return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_purpose_' + this.props.type });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'cp-list-type-cover' },
        _react2.default.createElement(
          _baseButtons.TextButton,
          {
            key: this.props.type,
            handleClick: this.handleClick,
            'data-test-id': 'list-type-' + this.props.type,
            className: 'list-type-button' },
          _react2.default.createElement(
            'div',
            { className: 'list-type' },
            this.renderListTypeTitle()
          ),
          _react2.default.createElement(
            'div',
            { className: 'list-type-details' },
            _react2.default.createElement(_listJacketCover2.default, { listType: this.props.type })
          )
        ),
        this.renderDescription()
      );
    }
  }]);

  return ListTypeCover;
}(_baseBcReactComponent2.default);

ListTypeCover.propTypes = {
  type: _react.PropTypes.string,
  description: _react.PropTypes.element,
  handleClick: _react.PropTypes.func
};

exports.default = ListTypeCover;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/list-type-cover/components/ListTypeCover.component.js
// module id = 1314
// module chunks = 0